import { VContainer } from 'vuetify/lib/components/VGrid';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VContainer,[_c('span',{staticClass:"text-h6"},[_vm._v("Gesundheitskosten")]),_c('highcharts',{staticStyle:{"height":"100%"},attrs:{"options":_vm.chartOptions}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }